import { ref, watch } from "vue";
import { useUser } from "@/stores";
import router from "@/router";

export default () => {
  const userStore = useUser();

  const loadData = async () => {
    const currentURL = window.location.href;
    if (currentURL.includes("/explorer/")) {
      const storedData = localStorage.getItem("dumpStoreData");
      const data = JSON.parse(storedData);
      if (data) {
        userStore.user = data.user;
        userStore.activeTab = data.activeTab;
        userStore.activeRoute = data.activeRoute;

        if (
          userStore.activeTab &&
          userStore.activeTab == "login" &&
          window.location.href.includes("/r/")
        ) {
          return;
        }

        if (userStore.activeTab) {
          router.push(`${userStore.activeTab}`);
        }

        // if (userStore.activeTab != "explorer") {
        //   if (userStore.activeTab === "login") {
        //     router.push(`/login`);
        //     return
        //   }
        //   router.push(`/explorer/${userStore.activeTab}`);
        //   return
        // } else if (userStore.activeTab === "explorer") {
        //   router.push(`/explorer`);
        //   return
        // }
      }

      if (!userStore.activeRoute) {
        userStore.activeRoute = "login";
      }
    }
  };

  const saveData = () => {
    const data = {
      user: userStore.user,
      activeTab: userStore.activeTab,
      activeRoute: userStore.activeRoute,
    };
    localStorage.setItem("dumpStoreData", JSON.stringify(data));
  };

  // // Load data when the store is instantiated
  loadData();

  // // // Save data when these change
  // watch(
  //   [
  //     () => userStore.user,
  //     () => userStore.activeTab,
  //     () => userStore.activeRoute,
  //   ],
  //   saveData
  // );

  watch([() => userStore.activeTab, () => userStore.activeRoute], () => {
    saveData();
  });

  // const clearData = () => {
  //   localStorage.removeItem("dumpStoreData");
  // };

  return {
    loadData,
    saveData,
  };
};
